export default {
    state: {
        message: 0,
        appointMessage: 0,
        systemMessage: 0,
        userLoginInfo: {
            name: ""
        },

        commUnreadMsgCount:0
    },
    mutations: {
        setMessage(state, message) {
            //需处理的预约信息
            state.message = message;
        },
        setCommUnreadMsgCount(state,num){
            state.commUnreadMsgCount = num;
        },
        setSystemMessage(state, message) {
            //未读的系统信息
            state.systemMessage = message;
        },
        setUserLoginInfo(state, userLoginInfo) {
            state.userLoginInfo = userLoginInfo;
        },
        setUsername(state, name) {
            //console.log('name >>>', name)
            state.userLoginInfo.name = name;
            //console.log(state.userLoginInfo)
            localStorage.setItem('username', name)
        }
    },
    getters: {
        username: state => state.userLoginInfo.name,
        message: state => state.message,
        systemMessage: state => state.systemMessage,
        commUnreadMsgCount: state => state.commUnreadMsgCount,
    }
}
